export const MUPDF_LOADED = 'MUPDF_LOADED';
//# sourceMappingURL=index.js.map